import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { CategoryOfCompanyCriteria } from './filter-category-of-company.model';
import { LoggingService } from '@services/logging.service';
import { FilterService } from '@services/filter.service';
import { LookupService } from '@services/lookup.service';
import { SearchStrategyService } from '@services/search-strategy.service';
import { StudySearchStrategy } from '@models/searchStrategy.model';

import { forkJoin, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import * as Constants from '@shared/_constants';
import { FilterUtilService } from '../shared/filter-util.service';
import { AccessType } from '@shared/_constants';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-filter-category-of-company',
  templateUrl: './filter-category-of-company.component.html',
  styleUrls: ['./filter-category-of-company.component.css'],
  providers: [SearchStrategyService],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  encapsulation: ViewEncapsulation.None,
})
export class FilterCategoryOfCompanyComponent implements OnInit {
  @Input() filter: any;
  @Input() submitClicked: boolean;
  @Input() readOnly = false;

  formDirty = false;
  companyCategories: TreeNode[];
  showLoader = false;
  accessType: number;
  searchStrategy: StudySearchStrategy;

  private destroy$ = new Subject();

  constructor(
    private lookupService: LookupService,
    private logger: LoggingService,
    private searchStrategyService: SearchStrategyService,
    private filterService: FilterService,
    private filterUtil: FilterUtilService
  ) {}

  ngOnInit() {
    this.loadInitialData();
  }

  public loadInitialData() {
    this.logger.info(this.constructor.name, Constants.LoggerMessages.LOGGER_NGONINIT, Constants.LoggerMessages.LOGGER_START);

    this.searchStrategy = this.searchStrategyService.studySearchStrategy;
    this.filterUtil.spinnerRS.next(true);

    const companyCategoriesBySize$ = this.filterService.getCompanyCategoriesBySize$(this.readOnly);
    const companyCategoryAccessType$ = this.lookupService.GetCompanyCategoryAccessType$(this.searchStrategy.studySearchStrategyId);

    forkJoin([companyCategoriesBySize$, companyCategoryAccessType$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([_companySizes, _accessType]) => {
        this.companyCategories = _companySizes;
        this.accessType = _accessType;
        if (this.accessType === AccessType.PartialAccess) {
          this.companyCategories = this.companyCategories.filter((x) => x.data !== '0');
        }
        this.initializeForm();
        this.filterUtil.spinnerRS.next(false);
      });
  }

  initializeForm() {
    if (this.filter && this.filter.categorySelection) {
      this.filter.categorySelection = this.companyCategories.filter((selection) =>
        (<CategoryOfCompanyCriteria>this.filter).categorySelection.find((s) => s.data === selection.data)
      );
    }
  }

  public sortSelection(selection: TreeNode[]): void {
    return this.filterUtil.sortSelection(selection);
  }
}
